import React, { useState } from 'react';
import Modal from '@ui-kit/components/modal';
import MainButton from '@ui-kit/components/mainButton';
import { container } from 'tsyringe';
import TermsAndConditions from '@base/features/termsAndConditions/termsAndConditions';
import { MAIN_ROUTES } from '@base/features/routing/constants/mainRoutes';
import { useHistory } from 'react-router-dom';
import { IInviteService } from '@base/features/game/model/interfaces';
import { IModalProvider } from '../model/interfaces';
import { t } from '@base/utils/helpers';

export default function ModalTermsAndConditions(props: { tableId: number }) {
  const history = useHistory();
  const modalProvider: IModalProvider = container.resolve('modalProvider');
  const inviteService: IInviteService = container.resolve('inviteService');
  const [rules, setRules] = useState(false);

  function goToGamePage() {
    history.push(MAIN_ROUTES.game);
  }

  function handleRules() {
    setRules((prevState) => !prevState);
  }

  function playTable() {
    inviteService.acceptInvite(props.tableId, true);
    setRules(false);
    goToGamePage();
    modalProvider.hideTermsAndConditions();
  }

  function closeModal() {
    setRules(false);
    modalProvider.hideTermsAndConditions();
  }
  return (
    <Modal title={'terms and conditions'}>
      <div className="modal-base-type">
        <h3 className="modal-base-type__title">{}</h3>

        <div className="modal-base-type__body">
          <TermsAndConditions id="modal_terms_and_condition" status={rules} handleStatus={handleRules} />
        </div>

        <div className="modal-base-type__buttons">
          <MainButton
            className="modal-base-type__button modal-base-type__button--cancel"
            onClick={closeModal}
          >
            {t('cancel')}
          </MainButton>
          <MainButton
            className="modal-base-type__button modal-base-type__button--apply"
            onClick={playTable}
            disabled={!rules}
          >
            {t('ok')}
          </MainButton>
        </div>
      </div>
    </Modal>
  );
}
